// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desktop_type_item_count-module__count--1Il-G{display:inline-block;padding:2px 5px;font-size:12px;line-height:1;background-color:rgba(27,31,35,0.08);-webkit-border-radius:20px;-moz-border-radius:20px;border-radius:20px;font-weight:600;color:inherit;float:right;margin-top:3px}.desktop_type_item_count-module__plus--jhUKJ{font-size:15px;font-weight:400;line-height:9px;color:inherit}\n", ""]);
// Exports
exports.locals = {
	"count": "desktop_type_item_count-module__count--1Il-G",
	"plus": "desktop_type_item_count-module__plus--jhUKJ"
};
module.exports = exports;
